import { render, staticRenderFns } from "./CreateChallenge.vue?vue&type=template&id=566cd8b9&"
import script from "./CreateChallenge.vue?vue&type=script&lang=js&"
export * from "./CreateChallenge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports